/* PLUMÉ — Maison theme behaviour. No dependencies. */
(function () {
'use strict';
var d = document, w = window, root = d.documentElement;
root.classList.add('js');
var reduce = w.matchMedia('(prefers-reduced-motion: reduce)').matches;
var cfg = w.PLUME || {};
var store = {
get: function (k) { try { return w.localStorage.getItem(k); } catch (e) { return null; } },
set: function (k, v) { try { w.localStorage.setItem(k, v); } catch (e) {} },
sget: function (k) { try { return w.sessionStorage.getItem(k); } catch (e) { return null; } },
sset: function (k, v) { try { w.sessionStorage.setItem(k, v); } catch (e) {} }
};
function $(s, c) { return (c || d).querySelector(s); }
function $$(s, c) { return Array.prototype.slice.call((c || d).querySelectorAll(s)); }
function intro() {
var el = $('.intro');
if (!el) { ready(); return; }
if (reduce || store.sget('plume-intro')) { el.remove(); ready(); return; }
store.sset('plume-intro', '1');
d.body.style.overflow = 'hidden';
setTimeout(function () { el.classList.add('is-draw'); }, 150);
setTimeout(function () { el.classList.add('is-drift'); }, 1500);
setTimeout(function () { el.classList.add('is-mark'); }, 2300);
setTimeout(function () { el.classList.add('is-leaving'); ready(); }, 3500);
setTimeout(function () { el.remove(); d.body.style.overflow = ''; }, 4700);
el.addEventListener('click', function () { el.classList.add('is-leaving'); ready(); setTimeout(function () { el.remove(); d.body.style.overflow = ''; }, 1200); });
}
function ready() { requestAnimationFrame(function () { d.body.classList.add('is-ready'); }); }
function header() {
var h = $('.site-header'); if (!h) return;
var hero = $('.hero');
function on() { h.classList.toggle('is-solid', !hero || w.scrollY > 40); }
on(); w.addEventListener('scroll', on, { passive: true });
var menu = $('.drawer-menu');
$$('[data-menu-open]').forEach(function (b) { b.addEventListener('click', function () { menu.classList.add('is-open'); menu.setAttribute('aria-hidden', 'false'); }); });
$$('[data-menu-close]').forEach(function (b) { b.addEventListener('click', function () { menu.classList.remove('is-open'); menu.setAttribute('aria-hidden', 'true'); }); });
}
function reveal() {
if (reduce || !('IntersectionObserver' in w)) return;
var els = $$('.reveal');
var io = new IntersectionObserver(function (es) {
es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.remove('is-pending'); io.unobserve(e.target); } });
}, { rootMargin: '0px 0px -8% 0px' });
els.forEach(function (el) {
var r = el.getBoundingClientRect();
if (r.top > w.innerHeight) { el.classList.add('is-pending'); io.observe(el); }
});
}
var CUR = {
NGN: { s: '₦', dp: 0 }, USD: { s: '$', dp: 0 }, GBP: { s: '£', dp: 0 }, EUR: { s: '€', dp: 0 }, CAD: { s: 'CA$', dp: 0 }, AED: { s: 'AED ', dp: 0 },
GHS: { s: 'GH₵', dp: 0 }, ZAR: { s: 'R', dp: 0 }, KES: { s: 'KSh', dp: 0 }, AUD: { s: 'A$', dp: 0 }
};
var TZ = { 'Europe/London': 'GBP', 'America/': 'USD', 'America/Toronto': 'CAD', 'America/Vancouver': 'CAD', 'Europe/': 'EUR', 'Asia/Dubai': 'AED', 'Africa/Accra': 'GHS', 'Africa/Johannesburg': 'ZAR', 'Africa/Nairobi': 'KES', 'Australia/': 'AUD', 'Africa/Lagos': 'NGN' };
var base = cfg.shopCurrency || 'NGN';
var rates = null, current = base;
function guess() {
var saved = store.get('plume-cur'); if (saved && CUR[saved]) return saved;
try {
var tz = Intl.DateTimeFormat().resolvedOptions().timeZone || '';
if (TZ[tz]) return TZ[tz];
for (var k in TZ) if (k.slice(-1) === '/' && tz.indexOf(k) === 0) return TZ[k];
} catch (e) {}
return base;
}
function fmt(cents, code) {
var c = CUR[code] || { s: code + ' ', dp: 2 };
var v = cents / 100;
if (code !== base && rates && rates[code]) v = v * rates[code];
if (code !== base) v = v < 50 ? Math.round(v) : Math.round(v / 5) * 5;
return c.s + v.toLocaleString('en-US', { maximumFractionDigits: c.dp, minimumFractionDigits: c.dp });
}
function paint() {
var code = (rates || current === base) ? current : base;
$$('[data-price]').forEach(function (el) {
var cents = parseInt(el.getAttribute('data-price'), 10); if (isNaN(cents)) return;
el.textContent = fmt(cents, code);
el.setAttribute('title', code !== base ? 'Approx. — charged as ' + fmt(cents, base) + ' at checkout' : '');
});
$$('[data-currency-label]').forEach(function (el) { el.textContent = code; });
$$('[data-currency-note]').forEach(function (el) { el.hidden = code === base; });
$$('.currency__panel button[data-code]').forEach(function (b) { b.setAttribute('aria-checked', b.getAttribute('data-code') === code ? 'true' : 'false'); });
}
function loadRates(cb) {
var cached = store.get('plume-rates');
if (cached) { try { var o = JSON.parse(cached); if (Date.now() - o.t < 432e5 && o.b === base) { rates = o.r; cb(); return; } } catch (e) {} }
if (cfg.preview && cfg.sampleRates) { rates = cfg.sampleRates; cb(); return; }
fetch('https://open.er-api.com/v6/latest/' + base).then(function (r) { return r.json(); }).then(function (j) {
if (j && j.rates) { rates = j.rates; store.set('plume-rates', JSON.stringify({ t: Date.now(), b: base, r: rates })); }
cb();
}).catch(function () { cb(); });
}
function currency() {
if (cfg.nativeCurrency) return;
current = guess();
$$('.currency').forEach(function (wrap) {
var btn = $('.currency__btn', wrap), panel = $('.currency__panel', wrap);
if (!btn || !panel) return;
btn.addEventListener('click', function (e) { e.stopPropagation(); if (wrap.hasAttribute('data-open')) wrap.removeAttribute('data-open'); else wrap.setAttribute('data-open', ''); btn.setAttribute('aria-expanded', wrap.hasAttribute('data-open')); });
panel.addEventListener('click', function (e) {
var b = e.target.closest('button[data-code]'); if (!b) return;
current = b.getAttribute('data-code'); store.set('plume-cur', current); wrap.removeAttribute('data-open'); paint();
});
});
d.addEventListener('click', function () { $$('.currency[data-open]').forEach(function (x) { x.removeAttribute('data-open'); }); });
paint();
loadRates(paint);
}
w.PlumePaintPrices = paint;
var drawer;
function openCart() { if (!drawer) return; drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false'); d.body.style.overflow = 'hidden'; }
function closeCart() { if (!drawer) return; drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true'); d.body.style.overflow = ''; }
function api(path, body) {
var opt = body ? { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) } : { headers: { Accept: 'application/json' } };
return fetch((cfg.routes && cfg.routes.root ? cfg.routes.root.replace(/\/$/, '') : '') + path, opt).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
}
function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
function renderCart(cart) {
$$('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
var body = $('[data-cart-body]'), foot = $('[data-cart-foot]'); if (!body) return;
if (!cart.items.length) {
body.innerHTML = '<div class="cart-empty"><p>' + esc((cfg.strings && cfg.strings.empty) || 'Your bag is light as a feather.') + '</p><a class="link-line" href="' + esc((cfg.routes && cfg.routes.collections) || '/collections/all') + '">Discover the collection</a></div>';
foot.hidden = true; return;
}
foot.hidden = false;
body.innerHTML = cart.items.map(function (i) {
var img = i.image ? '<img src="' + esc(i.image) + '" alt="">' : '';
return '<div class="cart-line" data-key="' + esc(i.key) + '"><a class="cart-line__img" href="' + esc(i.url) + '">' + img + '</a><div><p class="cart-line__title">' + esc(i.product_title) + '</p><div class="cart-line__meta">' + esc(i.variant_title && i.variant_title !== 'Default Title' ? i.variant_title : '') + '</div><div class="qty"><button type="button" data-qty="-1" aria-label="Decrease quantity">−</button><span>' + i.quantity + '</span><button type="button" data-qty="1" aria-label="Increase quantity">+</button></div></div><div class="cart-line__price"><span data-price="' + i.final_line_price + '"></span><button type="button" class="cart-line__remove" data-remove>Remove</button></div></div>';
}).join('');
var t = $('[data-cart-total]'); if (t) t.setAttribute('data-price', cart.total_price);
paint();
}
function cart() {
drawer = $('.cart-drawer'); if (!drawer) return;
$$('[data-cart-open]').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); api('/cart.js').then(renderCart); openCart(); }); });
$$('[data-cart-close]').forEach(function (b) { b.addEventListener('click', closeCart); });
d.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeCart(); });
drawer.addEventListener('click', function (e) {
var line = e.target.closest('.cart-line'); if (!line) return;
var key = line.getAttribute('data-key'), q = parseInt($('.qty span', line).textContent, 10);
if (e.target.closest('[data-qty]')) q += parseInt(e.target.closest('[data-qty]').getAttribute('data-qty'), 10);
else if (e.target.closest('[data-remove]')) q = 0; else return;
api('/cart/change.js', { id: key, quantity: Math.max(0, q) }).then(renderCart);
});
d.addEventListener('submit', function (e) {
var f = e.target; if (!f.matches('[data-product-form]')) return;
e.preventDefault();
var id = parseInt((f.querySelector('[name="id"]') || {}).value, 10);
var btn = f.querySelector('[type="submit"]'); var label = btn.innerHTML; btn.setAttribute('disabled', ''); btn.textContent = 'Adding…';
api('/cart/add.js', { items: [{ id: id, quantity: 1 }] }).then(function () { return api('/cart.js'); }).then(function (c) { renderCart(c); openCart(); })
.catch(function (err) { alertInline(f, (err && err.description) || 'This size could not be added. Please choose another.'); })
.then(function () { btn.removeAttribute('disabled'); btn.innerHTML = label; });
});
}
function alertInline(form, msg) { var m = form.querySelector('.form-msg') || d.createElement('p'); m.className = 'form-msg'; m.style.color = '#8A2B3A'; m.textContent = msg; form.appendChild(m); }
function product() {
$$('[data-product-form]').forEach(function (f) {
var data = f.querySelector('[data-variants]'); if (!data) return;
var variants = JSON.parse(data.textContent);
function sync() {
var sel = $$('[data-option]', f).map(function (g) { var c = g.querySelector('input:checked'); return c ? c.value : null; });
var v = variants.filter(function (x) { return x.options.every(function (o, i) { return sel[i] == null || o === sel[i]; }); })[0];
$$('[data-option]', f).forEach(function (g, gi) {
var b = g.closest('.opt'); var lab = b && b.querySelector('.opt__label b'); if (lab) lab.textContent = sel[gi] || '';
});
var btn = f.querySelector('[type="submit"]');
if (v) {
f.querySelector('[name="id"]').value = v.id;
$$('[data-pdp-price]').forEach(function (p) { p.setAttribute('data-price', v.price); });
btn.toggleAttribute('disabled', !v.available);
btn.querySelector('span').textContent = v.available ? ((cfg.strings && cfg.strings.add) || 'Add to bag') : ((cfg.strings && cfg.strings.soldOut) || 'Sold out');
if (w.history.replaceState) { var u = new URL(w.location.href); u.searchParams.set('variant', v.id); w.history.replaceState({}, '', u); }
}
paint();
}
f.addEventListener('change', sync);
});
var sb = $('.sticky-buy'), buy = $('.pdp__buy');
if (sb && buy && 'IntersectionObserver' in w) {
new IntersectionObserver(function (es) { sb.classList.toggle('is-on', !es[0].isIntersecting && es[0].boundingClientRect.top < 0); }).observe(buy);
sb.querySelector('button').addEventListener('click', function () { buy.querySelector('[type="submit"]').click(); });
}
}
function gate() {
var open = $('[data-pass-open]'), modal = $('.gate-pass');
if (open && modal) {
open.addEventListener('click', function () { modal.hidden = false; var i = modal.querySelector('input[type="password"]'); if (i) i.focus(); });
$$('[data-pass-close]', modal).forEach(function (b) { b.addEventListener('click', function () { modal.hidden = true; }); });
}
var cd = $('[data-countdown]');
if (cd) {
var t = Date.parse(cd.getAttribute('data-countdown'));
if (!isNaN(t)) {
var tick = function () {
var s = Math.max(0, Math.floor((t - Date.now()) / 1000));
var u = { d: Math.floor(s / 86400), h: Math.floor(s % 86400 / 3600), m: Math.floor(s % 3600 / 60), s: s % 60 };
for (var k in u) { var el = cd.querySelector('[data-' + k + ']'); if (el) el.textContent = String(u[k]).padStart(2, '0'); }
};
tick(); setInterval(tick, 1000);
} else cd.hidden = true;
}
}
function parallax() {
if (reduce) return;
var a = $('.hero__figure--front'), b = $('.hero__figure--back'); if (!a) return;
w.addEventListener('scroll', function () {
var y = Math.min(w.scrollY, 900);
a.style.transform = 'translateY(' + (y * .06) + 'px)';
if (b) b.style.transform = 'translateY(' + (y * -.04) + 'px)';
}, { passive: true });
}
function init() { intro(); header(); reveal(); currency(); cart(); product(); gate(); parallax(); }
if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', init); else init();
})();
